import SystemUsersWorkspace from '../../placeholders/SystemUsersWorkspace';

export default SystemUsersWorkspace;
